import * as React from 'react'

const SvgMap = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={142}
    height={120}
    viewBox="0 0 142 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#Map_svg__a)">
      <path
        d="m106.727 18.816 31.345-8.408c2.095-.561 4.088 1.174 3.828 3.329l-6.182 50.883 6.258 50.959c.26 2.134-1.692 3.864-3.771 3.349l-31.417-7.815-.061-92.292v-.005Z"
        fill="#E1CEFF"
      />
      <path
        d="M106.726 111.108 71.002 120V9.24l35.724 9.576v92.292ZM35.273 110.418l-31.345 8.408c-2.095.561-4.088-1.174-3.828-3.329l6.182-50.883-6.259-50.96c-.26-2.133 1.692-3.863 3.772-3.348l31.417 7.815.061 92.292v.005Z"
        fill="#AC94F0"
      />
      <path
        d="m35.274 18.127 35.729-8.888V120l-35.73-9.582V18.126Z"
        fill="#E1CEFF"
      />
      <path
        d="m106.691 64.62.061 46.487 31.417 7.816c2.079.515 4.037-1.215 3.772-3.349l-6.259-50.96h-28.991v.005Z"
        fill="#9865FC"
      />
      <path
        d="M70.967 64.62v55.375l35.724-8.892V64.62H70.967ZM6.247 64.62.064 115.498c-.26 2.154 1.733 3.89 3.828 3.328l31.346-8.407-.061-45.8H6.247Z"
        fill="#7130C9"
      />
      <path
        d="M35.238 64.62v45.794l35.729 9.581V64.62h-35.73Z"
        fill="#9865FC"
      />
      <path
        d="M88.862 43.216c-4.765 0-8.629 3.87-8.629 8.642 0 8.213 8.63 12.685 8.63 12.685s8.628-4.472 8.628-12.685c0-4.773-3.863-8.642-8.629-8.642Zm0 13.308a4.984 4.984 0 0 1-4.98-4.988 4.98 4.98 0 1 1 9.96 0 4.98 4.98 0 0 1-4.98 4.988Z"
        fill="#FFC103"
      />
      <path
        d="M88.862 56.524a4.984 4.984 0 0 1-4.98-4.988 4.98 4.98 0 1 1 9.96 0 4.98 4.98 0 0 1-4.98 4.988Z"
        fill="#440A78"
      />
      <path
        d="M48.525 0c-4.766 0-8.63 3.87-8.63 8.642 0 8.213 8.63 12.685 8.63 12.685s8.629-4.472 8.629-12.685C57.154 3.87 53.29 0 48.524 0Zm0 13.308a4.984 4.984 0 0 1-4.98-4.987 4.98 4.98 0 1 1 9.96 0 4.98 4.98 0 0 1-4.98 4.987Z"
        fill="#FFC103"
      />
      <path
        d="M48.525 13.307a4.984 4.984 0 0 1-4.98-4.987 4.98 4.98 0 1 1 9.96 0 4.98 4.98 0 0 1-4.98 4.987Z"
        fill="#440A78"
      />
      <path
        d="M20.32 70.051c-4.766 0-8.63 3.87-8.63 8.642 0 8.214 8.63 12.685 8.63 12.685s8.629-4.471 8.629-12.685c0-4.772-3.864-8.642-8.63-8.642Zm0 13.308a4.984 4.984 0 0 1-4.98-4.987 4.98 4.98 0 1 1 9.96 0 4.98 4.98 0 0 1-4.98 4.987Z"
        fill="#FFC103"
      />
      <path
        d="M20.32 83.359a4.984 4.984 0 0 1-4.98-4.987 4.98 4.98 0 1 1 9.96 0 4.98 4.98 0 0 1-4.98 4.987Z"
        fill="#440A78"
      />
      <path
        d="M123.164 83.052c-4.766 0-8.629 3.87-8.629 8.643 0 8.213 8.629 12.685 8.629 12.685s8.629-4.472 8.629-12.685c0-4.773-3.864-8.642-8.629-8.642Zm0 13.308a4.984 4.984 0 0 1-4.98-4.987 4.98 4.98 0 1 1 9.959 0 4.98 4.98 0 0 1-4.979 4.987Z"
        fill="#FFC103"
      />
      <path
        d="M123.164 96.36a4.984 4.984 0 0 1-4.98-4.987 4.981 4.981 0 1 1 9.96 0 4.981 4.981 0 0 1-4.98 4.987Z"
        fill="#440A78"
      />
    </g>
    <defs>
      <clipPath id="Map_svg__a">
        <path fill="#fff" d="M0 0h142v120H0z" />
      </clipPath>
    </defs>
  </svg>
)

export default SvgMap
